import { useLang } from "@/context/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const words = t.marquee.words;
  const repeated = [...words, ...words, ...words];

  return (
    <section
      className="py-16 md:py-24 border-y hairline overflow-hidden bg-[#050505]"
      aria-hidden
      data-testid="marquee-section"
    >
      <div className="marquee-track flex whitespace-nowrap gap-16 md:gap-24 items-center">
        {repeated.map((w, i) => (
          <span key={i} className="flex items-center gap-16 md:gap-24">
            <span
              className={
                i % 2 === 0
                  ? "font-display uppercase text-6xl md:text-8xl lg:text-9xl font-extrabold tracking-[-0.04em] text-outline"
                  : "font-display uppercase text-6xl md:text-8xl lg:text-9xl font-extrabold tracking-[-0.04em]"
              }
            >
              {w}
            </span>
            <span
              className="text-[color:var(--accent)] font-serif-italic text-5xl md:text-7xl"
              aria-hidden
            >
              ✳
            </span>
          </span>
        ))}
      </div>
    </section>
  );
}
